import { render, staticRenderFns } from "./DepartmentShowButton.vue?vue&type=template&id=ada21e36&scoped=true&"
import script from "./DepartmentShowButton.vue?vue&type=script&lang=ts&"
export * from "./DepartmentShowButton.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentShowButton.vue?vue&type=style&index=0&id=ada21e36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada21e36",
  null
  
)

export default component.exports